// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/

import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Componentfout opgevangen:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="min-h-screen bg-background text-foreground flex items-center justify-center p-6">
          <div className="max-w-sm space-y-4 text-center">
            <h1 className="text-xl font-semibold">Dit scherm kon niet worden geladen</h1>
            <p>Laad Cuplio opnieuw om het nogmaals te proberen.</p>
            <button type="button" onClick={() => window.location.reload()} className="rounded-xl bg-primary text-white px-5 py-3 font-semibold">
              Opnieuw laden
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
